<template>
  <div id="hres96u">
    <hrms-search-box-table v-show="indexDisp"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres96uIndex"
            searchBoxAlias="approve"
            :maxRowspan="maxRowspan.index"
            :detailEvent="detailEvent"
            :approveEvent="postHres96uSendApprove" />

    <detail v-show="detailDisp"
            :labelsButton="dash.button[dash.nowLang]"
            :labels="labels[dash.nowLang]"
            :detail="detail"
            :toggle="toggle"
            :nowLang="dash.nowLang" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres96u/mutation-types'
import detail from 'components/hres96u/detail'
import moment from 'moment'

export default {
  name: 'hres96u',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY')
    }
  },
  created () {
    this.receivedHres96uColumnsLabels()
    this.receivedHres96uIndex()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES96U_INDEX_DISP,
      detailDisp: types.GET_HRES96U_DETAIL_DISP,
      maxRowspan: types.GET_HRES96U_MAX_ROWSPAN,
      columns: types.GET_HRES96U_COLUMNS,
      labels: types.GET_HRES96U_LABELS,
      index: types.GET_HRES96U_INDEX,
      indexSelected: types.GET_HRES96U_INDEX_SELECTED,
      detail: types.GET_HRES96U_DETAIL
    })
  },
  methods: {
    pageDetail (event) {
      let searchParams = {
        p_codempid: this.indexSelected.codempid,
        p_dtereq: this.indexSelected.dtereq,
        p_numseq: this.indexSelected.numseq
      }
      this.receivedHres96uDetail(searchParams)
      this.toggle('detail')
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES96U_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES96U_PAGE,
      receivedHres96uColumnsLabels: types.RECEIVED_HRES96U_COLUMNS_LABELS,
      receivedHres96uIndex: types.RECEIVED_HRES96U_INDEX,
      receivedHres96uDetail: types.RECEIVED_HRES96U_DETAIL,
      postHres96uSendApprove: types.POST_HRES96U_SEND_APPROVE
    })
  },
  components: {
    detail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?1ae83064